import { CSSProperties, useEffect } from "react";
import environment from "../../config/environment";

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

const AdBanner = (props: {
  customclass?: string;
  "data-ad-slot": string;
  "data-ad-format": "auto" | "rectangle" | "vertical" | "horizontal";
  "data-full-width-responsive": "true" | "false";
}) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);

  const devStyles: CSSProperties = {};

  if (environment.env === "development") {
    devStyles.position = "relative";
    devStyles.backgroundColor = "rgba(5, 188, 180, 0.3)";
    devStyles.fontWeight = "bold";
  }

  return (
    <ins
      className={["adsbygoogle", "adbanner-customize", props.customclass]
        .filter((c) => c)
        .join(" ")}
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
        overflow: "hidden",
        ...devStyles,
      }}
      data-ad-client={process.env.NEXT_PUBLIC_GOOGLE_ADS_CLIENT_ID}
      {...props}
    >
      {environment.env === "development" && (
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {props["data-ad-slot"]}
        </span>
      )}
    </ins>
  );
};
export default AdBanner;
